import React from "react";
import {
  Grid,
  GridItem,
  Link,
  Image,
  Text,
  Center,
  Heading,
  Box,
} from "@chakra-ui/react";

const skill = [
  {
    icon: "https://www.shutterstock.com/image-illustration/programming-language-3d-icon-illustration-600nw-2174501027.jpg",
    title: "C++",
    link: "https://isocpp.org/",
  },
  {
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    title: "HTML",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    title: "CSS",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    icon: "https://i.pinimg.com/originals/be/d3/0d/bed30ddfa5d434e827c775ac9a3b0d38.jpg",
    title: "Bootstrap",
    link: "https://getbootstrap.com/",
  },
  {
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    title: "Javascript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    icon: "https://cdn.worldvectorlogo.com/logos/react-2.svg",
    title: "React",
    link: "https://react.dev",
  },
  {
    icon: "https://www.pixelbird.com.au/wp-content/uploads/2020/02/nodejs-image.png",
    title: "Node.js",
    link: "https://nodejs.org/en",
  },

  {
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    title: "Mongo DB",
    link: "https://www.mongodb.com/",
  },

  {
    icon: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
    title: "Express",
    link: "https://expressjs.com/",
  },
  {
    icon: "https://dgdeepon.github.io/static/media/chakra-ui_title2-400x400-removebg-preview.fc0f93596462cd01a157.png",
    title: "Chakra UI",
    link: "https://chakra-ui.com/",
  },
  {
    icon: "https://mui.com/static/logo.png",
    title: "MUI",
    link: "https://mui.com/",
  },
  {
    icon: "https://i0.wp.com/www.primefaces.org/wp-content/uploads/2018/05/primereact-logo.png?fit=1000%2C1000&ssl=1&w=640",
    title: "Prime React",
    link: "https://primereact.org/",
  },
  {
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    title: "Git",
    link: "https://git-scm.com/",
  },
  {
    icon: "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
    title: "GitHub",
    link: "https://github.com/",
  },
  {
    icon: "https://w7.pngwing.com/pngs/627/244/png-transparent-docker-logo-logos-logos-and-brands-icon-thumbnail.png",
    title: "Docker",
    link: "https://www.docker.com/",
  },
  {
    icon: "https://www.drupal.org/files/project-images/nextjs-icon-dark-background.png",
    title: "Next Js",
    link: "https://nextjs.org//",
  },
];

export default function Skills() {
  return (
    <Box py={["0px", "60px", "80px"]} id="skills">
      <Center pb="30px" textAlign="center">
        <Heading color="#B0BEC5">Technologies and Tools</Heading>
      </Center>
      <Grid
        className="skills-card"
        p={["4%", "0%", "0%", "0%"]}
        w={["100%", "80%", "85%", "80%", "70%"]}
        gridTemplateColumns={[
          "repeat(2,1fr)",
          "repeat(3,1fr)",
          "repeat(4,1fr)",
          "repeat(5,1fr)",
        ]}
        gap={4}
        margin={"auto"}
      >
        {skill.map(({ icon, title, link }) => {
          return (
            <GridItem
              key={Math.random()}
              padding={"35px"}
              overflow="hidden"
              style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            >
              <Link href={link} target="_blank">
                <Image
                  margin="auto"
                  className="skills-card-img"
                  src={icon}
                  w="80%"
                  transition="all .1s ease-in-out"
                  _hover={{
                    transform: "scale(1.1)",
                  }}
                  borderRadius="10%"
                />
              </Link>
              <Text
                className="skills-card-name"
                textAlign={"center"}
                fontSize={["md", "lg", "lg", "xl"]}
                color="#fff"
              >
                {title}
              </Text>
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
}
